/* eslint-disable no-console */
import fetch from '@/utils/fetch';
import { message } from 'antd';
import cookie from '@/utils/cookie';
import getShopType from '@/utils/getShopType';
import { getRootPower, getPoweredMenu } from '@/utils/power';
import menu from '@/menu';
import { InferModelProps } from '@/store/withStore';

const model = {
  state: {
    // 用户
    accountInfo: {}, // 当前登录账号数据
    // 店铺
    shopItem: {
      id: '15998082420222',
      ShopStatus: {
        status: 0,
        type: 0,
      },
      shopDetail: {
        shop_id: 15998082420222,
        is_special_shop: 2,
        shop_name: '丰食',
        shop_logo:
          'http://sems-1254389369.picgz.myqcloud.com/audit/bed3bfaf7d7b0424dc49b33cd66e263a_15816854453645.png?imageView2/1/w/140/h/140.png',
        content: '丰食⾯向企业员⼯市场的送餐服务，专注于企业员工专属福利，集合品质餐饮，安心送达。',
        is_deleted: 0,
        shop_status: 1,
        sub_status: 0,
        business_status: 1,
        is_cater: 0,
        week_business_time: '{"start_time":"00:00","end_time":"23:59"}',
        is_close: 0,
        cls_shop_id: 0,
        sfjs_shop_id: '',
        is_union_shop: 1,
        union_type: 1,
        ext_info: '',
        mp_auth: 1,
        sub_shop_id: 0,
        start_time: '00:00',
        end_time: '23:59',
        saas_logistical_pos_flag: 0,
        agent_id: null,
        agent_name: null,
      },
      roleDetail: [
        {
          role_id: 16,
          role_name: '高级管理员',
        },
      ],
      roleDetailIds: [16],
      roleIds: [16],
    }, // 店铺数据

    union_shop_id: null, // 多商户 id
    shop_id: null, // 店铺 id
    sub_shop_id: null, // 子门店 id
    shopType: null, // 'single': 单门店，'main': 多门店-总部，'sub': 多门店-子店
    shopName: null, // 店铺名称

    isFood: false, // true: 餐饮版，false: 通用版
    isSpecialShop: false, // true: 特约商户，false: 非特约商户

    rootPower: {} as any, // 店铺权限
    loadedPower: false,
    // UI
    sideMenu: [], // 侧边栏菜单

    showLogListDot: false,
    logListLoading: false,
    exportLogList: [],
    // 不知道这啥
    expressSource: {}, // 快递公司列表
    cancelReasons: [], // 取消原因列表
    // 待发货单数
    payNum: 0,
    cityExpressSource: [], // 同城快递公司列表
    // 新关联但未上架的商品数量
    goodsNum: 0,
    packageList: [], // 可选套餐列表
    userInfo: { account_name: '', shop_name: '' },
    // 子门店列表
    subShopList: [],
    shopDetail: {}, // 店铺详情
    // 自动接单订单
    // autoOrders: {}, // order_process_success: 自动接单成功的订单 order_process_fail: 自动接单失败的订单
    // 多商户
    isPolymer: false, // true: 聚合平台，false: 非聚合平台
    isJoined: false, // true: 已入驻聚合，false: 普通商户
    joinedPolymerList: [], // 获取店铺入驻过的所有多商户平台
    allPolymerShopList: [], // 多商户平台店铺列表（通过 + 已撤销）
    polymerShopGroupList: [], // 多商户平台店铺分组列表
    polymerShopList: [], // 多商户平台店铺列表
    polymerShopIdMap: {}, // 多商户平台店铺 id - 店铺数据 map
    fastPayNotice: [], // 到店付提醒
    activeNotice: true, // 是否激活语音提示
    menuPower: {},
    angentName: '', // 门店所属商户名称
    change_price: 0, // 是否允许子门店改价
    isOpenAccount: true, // 查看是否已经开户绑卡 用来做全局拦截
    isGettingRightsLoading: true,
    lessonNoticeList: [], // 查看今日新课程列表 用来提示
    cityData: [],
    isIframe: false, // 是不是丰享嵌入过来的
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { basic }, getState }) => ({
    // hd校验
    async checkHD() {
      const isGray = false; // 需要新的灰度校验
      const isCookieHd = cookie.get('hd');
      if (isGray) {
        if (!isCookieHd) {
          cookie.set('hd', '8A4807D4CD78570101ED7E8D15A19104', '/'); // 区分灰度的cookie 用于nginx转发, path设置为根目录，防止css等资源加载不到
          // @ts-ignore
          window.location.reload(true); // 刷新获取转发后的灰度资源
        }
      } else if (isCookieHd) {
        cookie.remove('hd');
        // @ts-ignore
        window.location.reload(true);
      }
    },
    async checkOpenAccount() {
      const { saasAgentId } = getState().basic.accountInfo;
      if (saasAgentId) {
        const data = await fetch('/saasmerchant/web/payment/checkOpenAccount', {
          params: {
            saasAgentId,
          },
        });
        // 是否开户并且绑卡
        basic.setState({ isOpenAccount: data });
      }
    },
    async getLessonNoticeList() {
      // 今日新课程列表
      const data = await fetch('/saasmerchant/school/lesson/new/notice');
      basic.setState({ lessonNoticeList: data?.list });
    },

    // 获取用户信息，校验是否登录
    // http://wiki.sftcwl.com/pages/viewpage.action?pageId=3225256
    async getAccountInfo() {
      const data = await fetch('/saasmerchant/web/account/info');
      if (data) {
        basic.setState({ accountInfo: data });
        // 设置用户属性
        window.sensors?.login(data?.passportId || -1);
        window.sensors?.setProfile({ phone: data?.accountPhone || -1 });
      }
    },
    // 设置店铺信息，获取店铺权限数据
    async getShopData() {
      const {
        shopDetail: {
          shop_id,
          sub_shop_id,
          shop_name,
          is_cater,
          is_special_shop,
          is_union_shop,
          change_price,
          union_type,
          agent_name,
          saas_logistical_pos_flag, // 是否入驻丰食并且选择一站专送  条件场景（物流充值报表）
        },
        ShopStatus,
      } = getState().basic.shopItem;
      const { platformType = 'FS' } = getState().basic.accountInfo;

      const shopType = getShopType(ShopStatus);
      const isFood = is_cater === 1;
      const isSpecialShop = is_special_shop === 1;
      const isPolymer = is_union_shop === 1;
      const isSFPolymer = union_type === 1 && is_union_shop === 1;
      const isInSFYZZS = saas_logistical_pos_flag === 1;

      basic.setState({
        union_shop_id: shop_id, // 多商户 id，其实就是 shop_id，为方便使用，相同值另存一份 union_shop_id
        shop_id,
        sub_shop_id,
        shopType,
        shopName: shop_name,
        isFood,
        isSpecialShop,
        isPolymer,
        change_price,
        isSFPolymer,
        isInSFYZZS,
        angentName: agent_name,
      });
      // 获取权限数据
      const [data] = await Promise.all([
        // 只有两种saas 和fs
        fetch('/saasmerchant/web/auth/account/category/map', {
          params: { platformCode: platformType !== 'SAAS' ? 'FS' : 'SAAS' },
          type: 'GET',
        }),
      ]);
      if (data) {
        const rootPower = getRootPower(data.categoryMap);
        const sideMenu = getPoweredMenu(menu, rootPower);
        basic.setState({
          rootPower,
          loadedPower: true,
          sideMenu,
        });
      }
      basic.setState({ isGettingRightsLoading: false });
    },
    // 获取店铺详情
    async getShopDetail() {
      const { shop_id, sub_shop_id } = getState().basic;
      const data = await fetch('/merchant/shop/getshopdetail', {
        params: { shop_id, sub_shop_id },
      });
      if (data) {
        basic.setState({ shopDetail: data });
      }
    },
    // 设置导出日志新任务 icon
    setLogListDot(value) {
      basic.setState({ showLogListDot: value });
    },
    // 获取导出日志列表
    async getLogList() {
      basic.setState({ logListLoading: true });
      const result = await fetch('/saasmerchant/web/common/getexporttask', {
        type: 'POST',
      });
      const exportLogList = result || [];
      basic.setState({
        exportLogList,
        logListLoading: false,
      });
    },
    // 获取子门店列表（子门店列表）
    async getSubShopList(params: any = {}) {
      const { shop_id, sub_shop_id } = getState().basic;
      const canSetState = !params.forSelect;
      delete params.forSelect;
      const data = await fetch('/merchant/shop/subshoplist', {
        params: { shop_id, sub_shop_id, cur_page: 0, per_page: 0, ...params },
      });
      if (data && canSetState) {
        const subShopList = data.sub_shop_list.map(
          ({ sub_shop_id: value, shop_name: label, shop_flag, ...rest }) => ({
            value,
            label,
            isMain: shop_flag === 0,
            ...rest,
          }),
        );
        basic.setState({ subShopList });
      }
      return data;
    },
    // 获取多商户平台入驻过的所有店铺（通过 + 已撤销）
    async getAllPolymerShopList(shop_name) {
      const { union_shop_id } = getState().basic;
      const data = await fetch('/merchant/shopfs/fssubshoplist', {
        params: { union_shop_id, shop_name },
      });
      if (data) {
        const allPolymerShopList = data.map(
          ({ sub_shop_id: value, shop_name: label, shop_id }) => ({
            value,
            label,
            shop_id,
          }),
        );
        basic.setState({ allPolymerShopList });
      }
    },
    async getCityData() {
      const data = await fetch('saasmerchant/getAllAddress');
      basic.setState({ cityData: data });
    },

    // 初始化
    init() {
      basic.getCityData();
    },
    // 获取平台类型 0:全部 1:聚合版pc 2:餐饮版pc 4:通用版pc
    getPlatform() {
      const { isFood, isPolymer } = getState().basic;
      if (isPolymer) {
        return 1;
      }
      if (isFood) {
        return 2;
      }
      return 4;
    },
    setIsIframe(flag) {
      basic.setState({
        isIframe: flag,
      });
    },
  }),
};

export type BasicModelProps = InferModelProps<typeof model>;

export default model;
